var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kiko"},[_c('img',{staticClass:"kiko-leftwing",attrs:{"alt":"leftwing","src":require("../../assets/kiko-leftwing.png")}}),_c('img',{staticClass:"kiko-body",attrs:{"alt":"body","src":require("../../assets/kiko-body.png")}}),_c('img',{staticClass:"kiko-rightwing",attrs:{"alt":"rightwing","src":require("../../assets/kiko-rightwing.png")}})])
}]

export { render, staticRenderFns }